import React from 'react';
import html from "../../images/html.png";
import css from "../../images/css3.png";
import js from "../../images/js.png";
import react from "../../images/react.png";
import es6 from "../../images/es6.png";
import node from "../../images/node js.png";
import mongodb from "../../images/mongodb 2.png";
import express from "../../images/express 2.png";
import redux from "../../images/redux.png";
import rest from "../../images/rest api.png";
import git from "../../images/git.png";
import github from "../../images/github.png";
import npm from "../../images/npm.png";
import firebase from "../../images/firebase.png";
import heroku from "../../images/heroku.png";
import material from "../../images/marerial ui.png";
import chrome from "../../images/chrome dev tool.jpg";

const Skills = () => {
    return (
        <div className="text-danger text-center mt-5">
            <div class="container mt-5">
                <h3><span className="textColor fs-2 border-bottom border-info ">Skill Highlights</span></h3>
                <div class="row mt-5">
                    <div class="col border-info">                        
                        <img src={js} className="skillPhoto border border-info" alt="html"/>
                    </div>
                    <div class="col">
                        <img src={es6} className="skillPhoto" alt="html"/>
                    </div>
                    <div class="col">
                        <img src={react} className="skillPhoto" alt="html"/>
                    </div>
                    <div class="col">
                        <img src={rest} className="skillPhoto" alt="html"/>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col">                        
                        <img src={node} className="skillPhoto" alt="html"/>
                    </div>
                    <div class="col">
                        <img src={mongodb} className="skillPhoto" alt="html"/>
                    </div>
                    <div class="col">
                        <img src={express} className="skillPhoto" alt="html"/>
                    </div>
                    <div class="col">
                        <img src={redux} className="skillPhoto" alt="html"/>
                    </div>
                </div>                
                <div class="row mt-3">
                    <div class="col">
                        <img src={material} className="skillPhoto" alt="html"/>
                    </div>
                    <div class="col">
                        <img src={firebase} className="skillPhoto" alt="html"/>
                    </div>
                    <div class="col">
                        <img src={heroku} className="skillPhoto" alt="html"/>
                    </div>
                    <div class="col">
                        <img src={npm} className="skillPhoto" alt="html"/>
                    </div>
                </div>                
                <div class="row mt-3">
                    <div class="col">
                        <img src={git} className="skillPhoto" alt="html"/>
                    </div>
                    <div class="col">
                        <img src={github} className="skillPhoto" alt="html"/>
                    </div>
                    <div class="col">
                        <img src={chrome} className="skillPhoto" alt="html"/>
                    </div>
                </div>                
            </div>            
        </div>
    );
};

export default Skills;